import type { ExternalTableSchema } from '@packages/table-builder';

export const schedulerLogsTable: ExternalTableSchema = {
  metadata: {
    title: 'Job Scheduler Logs',
    entity: 'SchedulerLogs',
    description: 'Execution logs for a scheduled task.',
  },

  dataSource: {
    endpoint: '/api/scheduler/api/app/schedule-trigger/paginated-job-trigger-log-details',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'static.undefined',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      ScheduleTriggerLogStatusId: 'filters.logStatus',
    },
    filters: [
      {
        name: 'logStatus',
        placeholder: 'Log Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/scheduler/api/app/schedule-trigger-log-status/active-schedule-trigger-log-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'triggeredDateTime',
      header: 'Triggered Date Time',
      type: 'date',
      width: 200,
      sortable: true,
    },
    {
      field: 'failureReason',
      header: 'Failure Reason',
      type: 'text',
      width: 150,
      sortable: true,
    },
    {
      field: 'numberOfRetries',
      header: 'Number of Retries',
      type: 'number',
      width: 180,
      sortable: true,
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      width: 200,
      align: 'center',
      sortable: true,
      badge: {
        statusMap: {
          Scheduled: 'success',
          Processing: 'info',
          Completed: 'success',
          Retry: 'error',
          Failed: 'error',
        },
        defaultVariant: 'info',
      },
    },
  ],

  actions: {},

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Job Scheduler Logs',
      resizable: true,
      reorderable: true,
    },
  },
};
